import RecipientDetails from './ScannedItemCard/RecipientDetails';
import CardIdentifier from './ScannedItemCard/CardIdentifier';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { ScannedReturnShipping } from '../../models';
import { IconButton } from '@mui/material';
import { appUrl } from '@/utils/appUrl';

interface ScannedItemCardProps {
  shipping: ScannedReturnShipping;
  index: number;
  errorReason?: string;
  onRemove: (shippingNumber: number) => void;
}

const ScannedItemCard = ({
  shipping,
  index,
  errorReason,
  onRemove,
}: ScannedItemCardProps) => {
  const openShippingDetails = () => {
    window.open(
      appUrl(`/business/shipping/${shipping.shippingNumber}`),
      '_blank'
    );
  };

  const formattedAddress = shipping.destinationAddress
    ? `${shipping.destinationAddress.streetName || ''} ${shipping.destinationAddress.doorNumber || ''} ${shipping.destinationAddress.apartmentNumber ? `Apt ${shipping.destinationAddress.apartmentNumber}` : ''}`.trim()
    : 'Sin dirección';

  return (
    <div
      className={`group flex flex-col md:flex-row md:items-center gap-4 p-5 rounded-2xl border transition-colors ${
        errorReason
          ? 'bg-red-50 border-red-200'
          : 'bg-white border-gray-100 hover:bg-gray-50/50'
      }`}
    >
      <CardIdentifier
        index={index}
        shippingNumber={shipping.shippingNumber}
        commerceShippingNumber={shipping.commerceShippingNumber}
        commerceName={shipping.commerceName ?? undefined}
        onOpenDetails={openShippingDetails}
      />

      <RecipientDetails
        recipient={shipping.recipient ?? undefined}
        address={formattedAddress}
      />

      <div className='flex items-center gap-6 ml-auto'>
        {errorReason && (
          <span className='text-sm font-bold text-red-600 max-w-[260px]'>
            {errorReason}
          </span>
        )}
        <IconButton
          onClick={() => onRemove(shipping.shippingNumber)}
          size='small'
          title='Quitar del listado'
        >
          <DeleteIcon fontSize='small' />
        </IconButton>
      </div>
    </div>
  );
};

export default ScannedItemCard;
